import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-base" data-id="element-296" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-297" data-mp="cng1oereb36u">
        <div className="text-center mb-16" data-id="element-298" data-mp="cm52ytct4lml">
          <p className="text-olive font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-299" data-mp="7p65q1xujyk6">
            This product combines 6 complete standalone systems
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-extrabold mb-4 text-ink" data-id="element-300" data-mp="3c3mg05l6b4ts">
            <span className="text-brand" data-id="element-301" data-mp="3pv12imeaho5l">6 complete systems</span> in 1
          </h2>
          <p className="text-xl text-graphite" data-id="element-302" data-mp="3px43g1gzd1p3">
            150+ sessions ready to teach · All levels and contexts · Nothing to build from scratch
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-303" data-mp="2xd5igxbnsz26">
          {volumes.map((volume, index) => <motion.div key={volume.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-paper rounded-2xl border ${volume.popular ? 'border-brand shadow-[0_14px_36px_-24px_rgba(94,115,85,0.6)]' : 'border-silver-light'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-304" data-mp="2sf40ygtvt7st" data-mpi={index}>
              {volume.popular && <div className="absolute top-6 right-[-35px] bg-brand text-white font-bold text-xs py-1 px-10 rotate-45" data-id="element-305" data-mp="1vfze2m2hnx30">
                  START HERE
                </div>}
              <div className="flex items-center gap-4 mb-6" data-id="element-306" data-mp="24hyy7n8svha6">
                <span className="text-4xl" aria-hidden="true" data-id="element-307" data-mp="3buqyocte801r">
                  {volume.icon}
                </span>
                <div data-id="element-308" data-mp="3fuj78pise674">
                  <div className="text-olive font-bold text-sm uppercase tracking-wider" data-id="element-309" data-mp="3ftrf5ooeeqll">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-display font-extrabold leading-tight mt-1 text-ink" data-id="element-310" data-mp="1bs9bsxac4s7m">
                    {volume.title}
                  </h3>
                </div>
              </div>
              <p className="text-ink font-medium mb-6 italic border-l-2 border-gold pl-4" data-id="element-311" data-mp="1krwedmesw429">
                {volume.subtitle}
              </p>
              <div className="mb-6" data-id="element-312" data-mp="x3d26vsmr74w">
                <h4 className="text-sm font-bold text-graphite-light uppercase tracking-wider mb-2" data-id="element-313" data-mp="t18fyi4ihcsa">
                  What it solves in your teaching
                </h4>
                <p className="text-graphite text-sm leading-relaxed" data-id="element-314" data-mp="16ty3ws3lors1">{volume.problem}</p>
              </div>
              <ul className="space-y-3 mb-8 flex-grow" data-id="element-315" data-mp="11ztve4eosbou">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-316" data-mp="e9zjpq63st66">
                    <CheckCircle2 size={18} className="text-brand shrink-0 mt-0.5" aria-hidden="true" data-id="element-317" data-mp="9cz9r464v69s" />
                    <span className="text-graphite text-sm" data-id="element-318" data-mp="2psvyb75svff9">{bullet}</span>
                  </li>)}
              </ul>
              <div className="bg-cream border border-silver-light rounded-xl p-4 mt-auto" data-id="element-319" data-mp="2by3bdnnkywyn">
                <span className="text-olive font-bold block mb-1" data-id="element-320" data-mp="2gwwm58bhg9v4">Result:</span>
                <p className="text-ink text-sm" data-id="element-321" data-mp="34pd83tycclzp">{volume.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}